module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am772-9c5de9c5e43112a493f2584dd76c61bf.jpg";